import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useEffect, useState } from "react";
import * as React from "react";
import { httpclient } from "../../../../utils/httpClient";

const StyledHeaderTitle = styled(DialogTitle)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: "#fff",
  position: "relative",
  "& button": {
    position: "absolute",
    right: "15px",
    top: "15px",
    color: "#fff",
  },
}));

const RefundDialog = (props) => {
  const [dialogDetails, setDialogDetails] = useState({
    open: true,
    success: false,
  });
  const [refundReason, setRefundReason] = React.useState("");
  const [reasonCode, setReasonCode] = React.useState("");
  const [reasons, setReasons] = React.useState([]);

  useEffect(() => {
    props.sendToRefund(dialogDetails, refundReason, reasonCode);
  }, [dialogDetails, refundReason, reasonCode]);

  useEffect(() => {
    getReasonCode();
  }, []);

  const getReasonCode = () => {
    httpclient(
      `new-system/netsuite/order/get-cancel-reasons/${props.viewDetails.companyID}`
    ).then(({ data }) => {
      if (data) {
        setReasons(data.data);
      }
    });
  };

  const handleClose = () => {
    setDialogDetails({
      ...dialogDetails,
      open: false,
    });
  };

  const handleYes = () => {
    if (refundReason && reasonCode) {
      setDialogDetails({
        ...dialogDetails,
        open: false,
        success: true,
      });
    }
  };

  const handleChange = (event) => {
    setRefundReason(event.target.value);
    const selectedReason = reasons?.find(
      (reason) => reason.label === event.target.value
    );
    setReasonCode(selectedReason ? selectedReason.code : "");
  };

  return (
    <div>
      <Dialog
        open={dialogDetails.open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <StyledHeaderTitle id="alert-dialog-title">
          Refund this order?
        </StyledHeaderTitle>
        <DialogContent>
          <Box pt={3}>Are you sure you want to refund this order? </Box>

          <Box pt={3}>
            Please select the viable reason for refund.
          </Box>
          <Box pt={2} sx={{ minWidth: 240 }}>
            <FormControl fullWidth>
              <InputLabel id="refund-reason-label">required*</InputLabel>
              <Select
                labelId="refund-reason-label"
                id="refund-reason-select"
                value={refundReason}
                label="Reason"
                onChange={handleChange}
              >
                <MenuItem value={""}>
                  <em>Select Reason</em>
                </MenuItem>
                {reasons &&
                  reasons.map((reason) => (
                    <MenuItem key={reason.id} value={reason.label}>
                      {reason.label}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions styled={{ margin: "5px 10px" }}>
          <Button onClick={handleClose} color="error" variant="contained" autoFocus>
            No
          </Button>
          <Button
            onClick={handleYes}
            color="primary"
            variant="contained"
            autoFocus
            disabled={!refundReason || !reasonCode}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default RefundDialog;
